import React from "react";
import { IOrder } from "@market/interfaces/IOrder";
import moment from "moment";
import { MobileExpandedRow } from "@apps/MarketsApp/components/MobileExpandedRow";
import { Button } from "@appComponents/Button";
import { formatNumberWithCommas } from "@features/utils/functions";
import { MAIN_CURRENCY_LABEL } from "@bundles/consts";
import { decimalPlaces } from "@appComponents/CurrencyElement/CurrencyElement";
import { EordersTypes } from "@market/enums/OrdersTypes";
import classNames from "classnames";

type Props = {
  order: IOrder;
  onCancel: (id: number, type: EordersTypes) => void;
};

const typeLabels = {
  [EordersTypes.buy]: "Buy",
  [EordersTypes.sell]: "Sell",
};

export const MyOrderMobileExpandedRow = ({ order, onCancel }: Props) => {
  const currency =
    order.payment_currency?.toUpperCase() ?? MAIN_CURRENCY_LABEL.toUpperCase();

  const rows = [
    {
      label: "DATE",
      content: `${moment(order.created_at).format("DD MMM, YYYY h:mm A")}`,
    },
    {
      label: "TYPE",
      content: (
        <div
          className={classNames({
            "text-[#2D9C5E]": order.type === EordersTypes.buy,
            "text-[#E02020]": order.type === EordersTypes.sell,
          })}
        >
          {typeLabels[order.type]}
        </div>
      ),
    },
    {
      label: "PRICE",
      content: `${formatNumberWithCommas(
        Number(order.price ?? 0),
        decimalPlaces[order.payment_currency]
      )} ${currency}`,
    },
    {
      label: "AMOUNT",
      content: order.number_of_shares,
    },
    {
      label: "VALUE",
      content: `${formatNumberWithCommas(
        Number(order.value ?? 0),
        decimalPlaces[order.payment_currency]
      )} ${currency}`,
    },
    {
      label: "ACTION",
      content:
        order.status === "sold_out" ? (
          order.type === EordersTypes.buy ? (
            "Bought Out"
          ) : (
            "Sold Out"
          )
        ) : order.status !== "suspended" &&
          order.number_of_available_shares > 0 ? (
          <Button
            isSmall
            onClick={() => onCancel(order.id, order.type)}
            data-cy="cancel"
          >
            Cancel
          </Button>
        ) : (
          <Button isSmall disabled data-cy="cancel">
            Cancel
          </Button>
        ),
    },
  ];

  return <MobileExpandedRow rows={rows} />;
};
